// T290 — module-scope flags that must last a session but not outlive an account.
//
// This file exists to break an import cycle. The dismiss flag belongs to the
// banner and the reset belongs to logout, but AiKeyBanner imports useAuth from
// AuthContext, so having AuthContext import the banner back would close a loop
// through a React context — the kind that resolves fine until a bundler reorders
// two modules and one of them reads an undefined binding at init. Neither side
// imports the other now; both import this.
let aiKeyBannerDismissed = false;

export function isAiKeyBannerDismissed() {
  return aiKeyBannerDismissed;
}

export function dismissAiKeyBanner() {
  aiKeyBannerDismissed = true;
}

// Called on logout. Without it the flag survives into the next account's
// session, because logout calls setUser(null) and never reloads the page —
// hiding the "no AI key" banner from someone who genuinely has no AI key.
export function resetSessionFlags() {
  aiKeyBannerDismissed = false;
}
